<app-overlay
  [visible]="true"
  [container]="container"
  [overlayMask]="false"
  [animate]="false"
>
  <div
    #btnOpenEl
    class="btn-open"
    [@handleOpened]="!openedState"
    [ngStyle]="{ height: closedIndicatorHeight }"
  >
    <app-iconic class="icon" icon="assets/icons/caret-left.svg"></app-iconic>
  </div>

  <div
    #menuContainerEl
    class="menu-container"
    [ngStyle]="{ height: contentHeight }"
    [@handleOpened]="!!openedState"
    (@handleOpened.start)="onTriggerEventStart($event)"
    (@handleOpened.done)="onTriggerEventDone($event)"
  >
    <ng-container *ngIf="!contentTpl?.templateRef; else contentTplRef">
      <ng-content></ng-content>
    </ng-container>
  </div>
</app-overlay>

<ng-template #contentTplRef>
  <ng-container *appDeferRendering="!!(opened || opening)">
    <ng-template [ngTemplateOutlet]="contentTpl.templateRef"></ng-template>
  </ng-container>
</ng-template>
